/**
 * @fileoverview PUT handler for the "/companies/:company_id/free_trial/developers/:developer_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdFreeTrialDevelopersDeveloperIdCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdFreeTrialDevelopersDeveloperIdProps,
  PutFreeTrialDeveloperResult,
} from "./types";

export const putFreeTrialDeveloper = reactQueryMutationAdapter(
  companiesCompanyIdFreeTrialDevelopersDeveloperIdCacheKeys,
  (props: PutCompaniesCompanyIdFreeTrialDevelopersDeveloperIdProps): Promise<PutFreeTrialDeveloperResult> => {
    return fetch(
      `/companies/${props.companyId}/free_trial/developers/${props.developerId}`,
      "PUT",
      props.body,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
